import React, { FC } from 'react';
import { BoxProps, Icon, IconProps } from '@chakra-ui/react';
import { Plus } from 'react-feather';
import { MotionBox } from '../motion/MotionBox.ui';
import { MotionProps } from 'framer-motion';

type PlusToXRotatingIconPropsType = BoxProps & MotionProps;

interface I extends PlusToXRotatingIconPropsType {
  isPlus?: boolean;
  iconProps?: IconProps;
}

export const PlusToXRotatingIcon: FC<I> = (props) => {
  const { isPlus, iconProps = {}, ...rest } = props;

  return (
    <MotionBox
      animate={{
        transform: `rotate(${isPlus ? 0 : 45}deg)`,
      }}
      {...rest}
    >
      <Icon h={isPlus ? 6 : 7} w={isPlus ? 6 : 7} as={Plus} {...iconProps} />
    </MotionBox>
  );
};
